var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.co === true ? 'appCo' : ''],attrs:{"id":"app"}},[(_vm.co === false)?_c('header',{class:[_vm.indiv === true ? 'headerIndiv' : '', 'header']},[_c('router-view',{attrs:{"name":"header"}})],1):_vm._e(),_vm._v(" "),_c('section',{class:[
      _vm.indiv === true ? 'sectionWrapper' : '',
      _vm.co === true ? 'sectionConnexion' : '',
      'section-main'
    ]},[_c('router-view')],1),_vm._v(" "),_c('footer',{class:[
      _vm.indiv === true ? 'footerIndiv' : '',
      _vm.co === true ? 'footerCo' : '',
      'footer'
    ]},[_c('router-view',{attrs:{"name":"sidebar"}}),_vm._v(" "),(_vm.co === true)?_c('div',[_vm._v("V 0.1.4")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917b6b96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 